import { Component, Input, ViewChild } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { LayoutService } from '../services/layout.service';

@Component({
  standalone: false,
  template: `
    <div (dblclick)="copyToClipboard($event)" [ngStyle]="data.style">
      {{ data.value || '-' }}
      @if (data.enabled && !loading) {
        <nb-icon class="ms-2 editButton" icon="edit-outline" (click)="openDialog()"></nb-icon>
      }
      @if (loading) {
        <i class="fa fa-spinner fa-spin ms-1"></i>
      }
    </div>
    <ng-template #dialog>
      <nb-card>
        <nb-card-header>{{ data.title }}</nb-card-header>
        <nb-card-body>
          <input #inputField type="text" nbInput fullWidth class="mt-2" [value]="data.value" (keydown)="numberOnly($event)">
        </nb-card-body>
        <nb-card-footer>
          <button nbButton status="danger" class="float-end" (click)="closeDialog()">CLOSE</button>
          <button nbButton status="primary" class="float-end me-1" [disabled]="!inputField.value" (click)="edit()">EDIT</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
    `,
  styleUrls: ['./inline-edit-cell.component.scss'],
})
export class InlineEditCellComponent {
  @Input()
  data: any;
  loading: boolean = false;
  @ViewChild('inputField') inputField: any;
  @ViewChild('dialog') dialog: any;
  dialogRef: NbDialogRef<any>;
  numberRegex = new RegExp(/^\d*[,.]?\d*$/);
  
  constructor(
    private dialogService: NbDialogService,
    private layoutService: LayoutService
  ) {}

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  openDialog() {
    event.preventDefault();
    event.stopPropagation();
    this.loading = true;
    this.layoutService.setOverlaySubject(true);
    this.dialogRef = this.dialogService.open(this.dialog, { closeOnBackdropClick: false, closeOnEsc: true });
  }

  closeDialog() {
    this.loading = false;
    this.layoutService.setOverlaySubject(false);
    this.dialogRef.close();
  }

  edit() {
    this.data.action(this.data.id, parseInt(this.inputField.nativeElement.value), (updatedValue: number) => {
      if (updatedValue) {
        this.data.value = updatedValue;
        this.inputField.nativeElement.value = updatedValue;
      }
      this.closeDialog();
    });
  }

  copyToClipboard($event: any) {
    navigator.clipboard.writeText($event.target.textContent.replace(/\s+/g, ''));

    $event.target.classList.add('highlight');
    setTimeout(() => {
      $event.target.classList.remove('highlight');
    }, 300);
  }

  numberOnly(event) {
    if (this.numberRegex.test(event.key)) {
      return true;
    }

    if (['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Tab'].includes(event.code)) {
      return true;      
    } else {
      event.preventDefault();
      return false;  
    }
  }
}
